<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="units"
        @reset="resetHandle"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @select="selectHandle">
      <template slot="otherBtn">
        <el-button v-if="limits.delAllAuth" type="danger" :disabled="!selection.length" @click="deleteBatch">批量删除</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="编号">
            <el-input v-model.trim="filter.unitNo" placeholder="请输入计量单位编号" clearable/>
          </el-form-item>
          <el-form-item label="名称">
            <el-input v-model.trim="filter.unitName" placeholder="请输入计量单位名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <unit-edit ref="unitEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import UnitEdit from "./UnitEdit";
  export default {
    name: "UnitList",
    components: { viewTable, UnitEdit },
    data() {
      return {
        selection: [],
        limits: {
          addAuth: this.$auth(142),
          editAuth: this.$auth(144),
          delAuth: this.$auth(145),
          delAllAuth: this.$auth(143),
        },
        filter: {
          unitNo: "",
          unitName: "",
        },
        columnsProperty: [
          {
            key: "unitNo",
            width: 100,
            align: "center",
          },
          {
            key: "unitName",
            minWidth: 150,
            tooltip: true,
          },
          {
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            key: "createTime",
            width: 160,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.unitEdit.open(row);
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "units", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      deleteBatch() {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkId);
        });
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "units/deleteBatch", ids).then((resp) => {
            if (resp.success) {
              this.loadData();
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },
    },
  };
</script>
